import React, { useState,useEffect } from 'react';
import { Calendar, Clock, Mail, Users, DollarSign, Truck, FileText, Settings, Plus, Trash2, Bell, CheckCircle, AlertCircle, Download, Play, Pause, RotateCcw ,Loader2} from 'lucide-react';
import config from '../config/config';
import axios from 'axios';
const AdminAutomationSettings = () => {
  const [activeTab, setActiveTab] = useState('fees');
  const [termEdit, setTermEdit]=useState(true);
  const [notifications, setNotifications] = useState([]);
const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
   const getCsrfToken = async () => {
    try {
      await axios.get(`${config.API_URL}/sanctum/csrf-cookie`, { withCredentials: true });
      const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    } catch (error) {
      console.error('Failed to fetch CSRF token:', error);
      return null;
    }
  };
  // Axios instance with interceptors for CSRF token
  const api = axios.create({
    baseURL: config.API_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    withCredentials: true,
  });
   // Add interceptor to include CSRF token and Authorization header
  api.interceptors.request.use(async (config) => {
    const xsrfToken = await getCsrfToken();
    if (xsrfToken) {
      config.headers['X-XSRF-TOKEN'] = xsrfToken;
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }, (error) => Promise.reject(error));

  // Handle 419 errors by refreshing CSRF token
  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 419) {
        const xsrfToken = await getCsrfToken();
        if (xsrfToken) {
          error.config.headers['X-XSRF-TOKEN'] = xsrfToken;
          return api.request(error.config); // Retry the request
        }
      }
      return Promise.reject(error);
    }
  );
  // Fee Automation State
  const [termDates, setTermDates] = useState([]);


    const fetchTerms = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullterms`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });

      setTermDates(res.data.terms2 || res.data || []);
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };

  const fetchNotifications = async () => {
    const token = localStorage.getItem('token');
    try {
      const res = await axios.get(`${config.API_URL}/api/pullNotifications/termNotification`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setFeeSettings(res.data.feenotifications?.[0] || []);
      setTransportSettings(res.data.transportnotifications || []);
      setExpenseSettings(res.data.expenseNotifications || []);
      setPayrollSettings(res.data.payrollnotifications?.[0] || { approvers: [], reportRecipients: [] }); // Use payrollnotification
     setLoading(false);
    } catch (err) {
      console.error('Error fetching notifications:', err);
     
    }
  };



    const handleSaveTerm = async (termDetails) => {
    const token = localStorage.getItem('token');
    try {


        const payload = {
        id:termDetails?.id,
        term: termDetails?.name || termDates.name,
        year: termDetails?.year,
        startDate: termDetails?.startDate || termDates.startDate,
        endDate: termDetails?.endDate || termDates.endDate,
        generateBefore: termDetails?.generateBefore || termDates.generateBefore,
        reminderFrequency: termDetails?.reminderFrequency || termDates.reminderFrequency,
      };

       const response = termEdit
        ? await api.post('/api/updateTermDetails', payload): 
        await api.post('/api/saveTermDetails', payload);

      
      if(response.data.status==1){
           if(response.data.termstatus==1){
            setTermEdit(true);
           }
           fetchTerms();
        testAutomation('Term settings');
      }else{
        alert('Failed')
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
  };

  useEffect(() => {
    fetchTerms();
    fetchNotifications();
  }, []);

  const [feeSettings, setFeeSettings] = useState();

  

  // Payroll State
  const [payrollSettings, setPayrollSettings] = useState();

  // Expense State
  const [expenseSettings, setExpenseSettings] = useState([]);

  // Transport State
  const [transportSettings, setTransportSettings] = useState();

  // Payslip State
  const [payslipSettings, setPayslipSettings] = useState({
    sendDate: '25',
    sendTime: '09:00',
    frequency: 'monthly',
    recipients: ['teacher@school.com'],
    emailSubject: 'Your Payslip for [MONTH] [YEAR]',
    emailBody: 'Dear [EMPLOYEE_NAME],\n\nPlease find attached your payslip for [MONTH] [YEAR].\n\nIf you have any questions regarding your payslip, please contact the HR department.\n\nBest regards,\nHR Team',
    includeAttachments: true,
    passwordProtected: true
  });

  // System State
  const [systemStatus, setSystemStatus] = useState({
    feeGeneration: { status: 'active', nextRun: 'Jan 15, 2025', lastRun: 'Dec 15, 2024' },
    payrollProcessing: { status: 'pending', nextRun: 'Jan 4, 2025', lastRun: 'Dec 4, 2024' },
    transportInvoices: { status: 'scheduled', nextRun: 'Feb 1, 2025', lastRun: 'Jan 1, 2025' },
    payslips: { status: 'active', nextRun: 'Jan 25, 2025', lastRun: 'Dec 25, 2024' },
    expenses: { status: 'active', nextRun: 'Feb 1, 2025', lastRun: 'Jan 1, 2025' }
  });

  const [isTestMode, setIsTestMode] = useState(false);
  const [automationLogs, setAutomationLogs] = useState([
    { id: 1, type: 'Fee Generation', status: 'Success', timestamp: '2024-12-15 09:00', details: '150 fees generated successfully' },
    { id: 2, type: 'Payroll', status: 'Success', timestamp: '2024-12-04 10:00', details: '45 payroll records processed' },
    { id: 3, type: 'Transport Invoice', status: 'Success', timestamp: '2024-12-01 08:00', details: '200 transport invoices sent' }
  ]);

  const tabs = [
    { id: 'fees', label: 'Fee Automation', icon: DollarSign },
    { id: 'payroll', label: 'Payroll', icon: Users },
    { id: 'expenses', label: 'Expenses', icon: FileText },
    { id: 'transport', label: 'Transport', icon: Truck },
   // { id: 'payslips', label: 'Payslips', icon: Mail }
  ];

  // Helper Functions
  const addNotification = (message, type = 'info') => {
    const newNotification = {
      id: Date.now(),
      message,
      type,
      timestamp: new Date().toLocaleTimeString()
    };
    setNotifications(prev => [newNotification, ...prev.slice(0, 4)]);
  };

  const addTermDate = () => {
    setTermEdit(false);
    const newTerm = {
      id: Date.now(),
      name: '',
      startDate: '',
      endDate: '',
      feeAmount: '',
      generateBefore: '3weeks',
      reminderFrequency: '1week'
    };
    setTermDates([...termDates, newTerm]);
  };

 const removeTermDate = async (id) => {
  // Ensure confirm is used in a browser context
  if (typeof window !== 'undefined' && !window.confirm('Are you sure you want to remove this term?')) {
    return; // Exit if user clicks "Cancel"
  }

  const token = localStorage.getItem('token');
  try {
    const res = await axios.get(`${config.API_URL}/api/removeTermDate/` + id, {
      headers: { Authorization: `Bearer ${token}` },
      withCredentials: true,
    });
    if (res.data.status == 1) {
      window.alert('Term removed successfully'); // Explicitly use window.alert
       fetchTerms();
    }
  } catch (err) {
    console.error('Error fetching terms:', err);
    window.alert('Failed to remove term. Please try again.');
  }
};

  const updateTermDate = (id, field, value) => {
    setTermDates(termDates.map(term => 
      term.id === id ? { ...term, [field]: value } : term
    ));
  };

  const addExpense = () => {
    const newExpense = {
      id: Date.now(),
      name: '',
      amount: '',
      frequency: 'monthly',
      processDate: '1',
      description: '',
      category: '',
      vendor: ''
    };
    setExpenseSettings([...expenseSettings, newExpense]);
  };

  const removeExpense = (id) => {
    setExpenseSettings(expenseSettings.filter(expense => expense.id !== id));
  };

  const updateExpense = (id, field, value) => {
    setExpenseSettings(expenseSettings.map(expense => 
      expense.id === id ? { ...expense, [field]: value } : expense
    ));
  };

  const addEmail = (type, setter, current) => {
    setter({ ...current, [type]: [...current[type], ''] });
  };

  const removeEmail = (type, index, setter, current) => {
    setter({ ...current, [type]: current[type].filter((_, i) => i !== index) });
  };

  const updateEmail = (type, index, value, setter, current) => {
    const updated = [...current[type]];
    updated[index] = value;
    setter({ ...current, [type]: updated });
  };

  const testAutomation = (type) => {
   // setIsTestMode(true);
    //addNotification(`Testing ${type} automation...`, 'info');
    
    setTimeout(() => {
      //setIsTestMode(false);
      addNotification(`${type} completed successfully`, 'success');
    }, 3000);
  };

  const saveTermNotificationSettings = async () => {
    const token = localStorage.getItem('token');
    try {


        const payload = {
        id:feeSettings.id,
        notificationTime: feeSettings.notificationTime,
        emailTemplate: feeSettings.emailTemplate,
        autoReminders: feeSettings.autoReminders,
      };

       const response =await api.post('/api/saveTermNotificationSettings', payload);

      
      if(response.data.status==1){
            addNotification('Invoice generation notifications settings set successfully', 'success');
      }else{
        alert('Failed')
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
   
    // TODO: Implement API call to save settings
  };

   const savePayrollNotificationSettings = async () => {
    const token = localStorage.getItem('token');
    try {


        const payload = {
        id:2,
        processingMode: payrollSettings.processingMode,
        processDay:payrollSettings.processDay,
        processTime:payrollSettings.processTime,
        frequency:payrollSettings.frequency,
        approvers:payrollSettings.approvers,
        reportRecipients:payrollSettings.reportRecipients,
      };

       const response =await api.post('/api/savePayrollNotificationSettings', payload);

      
      if(response.data.status==1){
            addNotification('Payroll generation notifications settings set successfully', 'success');
      }else{
        alert('Failed')
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
   
    // TODO: Implement API call to save settings
  };

  const saveExpenseNotificationSettings = async () => {
    const token = localStorage.getItem('token');
    try {


        const payload = {
        expenses:expenseSettings
      };

       const response =await api.post('/api/saveExpenseNotificationSettings', payload);

      
      if(response.data.status==1){
            addNotification('Expense notifications settings set successfully', 'success');
      }else{
        alert('Failed');
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
   
    // TODO: Implement API call to save settings
  };

  const saveTransportNotificationSettings = async () => {
    const token = localStorage.getItem('token');
    try {


        const payload = {
        id:3,
        invoiceDate: transportSettings.invoiceDate,
        frequency:transportSettings.frequency,
        notifyParents:transportSettings.notifyParents,
        amount:transportSettings.amount,
        sendTime:transportSettings.sendTime,
        smsTemplate:transportSettings.smsTemplate,
      };

       const response =await api.post('/api/saveTransportNotificationSettings', payload);

      
      if(response.data.status==1){
            addNotification('Transport notifications settings set successfully', 'success');
      }else{
        alert('Failed');
      }
    } catch (err) {
      console.error('Error fetching terms:', err);
    }
   
    // TODO: Implement API call to save settings
  };

  const saveSettings = () => {
    addNotification('Settings saved successfully', 'success');
    // TODO: Implement API call to save settings
  };

  const exportSettings = () => {
    const settings = {
      termDates,
      feeSettings,
      payrollSettings,
      expenseSettings,
      transportSettings,
      payslipSettings
    };
    
    const dataStr = JSON.stringify(settings, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = 'automation-settings.json';
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
    
    addNotification('Settings exported successfully', 'success');
  };


 if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          <p className="text-base text-gray-600 font-medium">Loading settings...</p>
        </div>
      </div>
    );
  }
  // Render Functions
  const renderFeeAutomation = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <Calendar className="mr-3 text-blue-600" size={24} />
          Term Dates & Fee Generation
        </h3>
        
        {termDates.map((term) => (
          <div key={term.id} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Term Name</label>
                <input
                  type="text"
                  placeholder="e.g., First Term"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.name}
                  onChange={(e) => updateTermDate(term.id, 'name', e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.startDate}
                  onChange={(e) => updateTermDate(term.id, 'startDate', e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                <input
                  type="date"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.endDate}
                  onChange={(e) => updateTermDate(term.id, 'endDate', e.target.value)}
                />
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 items-end">
             {/* <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Fee Amount ($)</label>
                <input
                  type="number"
                  placeholder="0.00"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.feeAmount}
                  onChange={(e) => updateTermDate(term.id, 'feeAmount', e.target.value)}
                />
              </div>*/}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Generate Before</label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.generateBefore}
                  onChange={(e) => updateTermDate(term.id, 'generateBefore', e.target.value)}
                >
                  <option value="1days">1 day before</option>
                  <option value="2days">2 days before</option>
                  <option value="3days">3 days before</option>
                  <option value="4days">4 days before</option>
                  <option value="5days">5 days before</option>
                  <option value="6days">6 days before</option>
                  <option value="1week">1 week before</option>
                  <option value="2weeks">2 weeks before</option>
                  <option value="3weeks">3 weeks before</option>
                  <option value="1month">1 month before</option>
                  

                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Reminder Frequency</label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  value={term.reminderFrequency}
                  onChange={(e) => updateTermDate(term.id, 'reminderFrequency', e.target.value)}
                >
                  <option value="daily">Daily until paid</option>
                  <option value="2days">2 days after</option>
                  <option value="3days">3 days after</option>
                  <option value="4days">4 days after</option>
                  <option value="5days">5 days after</option>
                  <option value="6days">6 days after</option>
                    <option value="1week">1 week after</option>
                   <option value="2week">2 weeks after</option>
                  <option value="3week">3 weeks after</option>
                   <option value="1month">1 month after</option>
                  
                  <option value="none">No reminders</option>
                </select>
              </div>
              <div className="flex gap-2">
             <button
                  onClick={() => { handleSaveTerm(term)}}
                  className="px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-500 transition-colors"
                  disabled={isTestMode}
                >
                  {isTestMode ? <RotateCcw className="animate-spin" size={16} /> : '' } Save
                </button>
                {termDates.length > 1 && (
                  <button
                    onClick={() => removeTermDate(term.id)}
                    className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
        
        <button
          onClick={addTermDate}
          className="flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors"
        >
          <Plus size={20} className="mr-2" />
          Add Term Date
        </button>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
        <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
          <Bell className="mr-2 text-orange-600" size={20} />
          Notification Settings
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Notification Time</label>
            <input
              type="time"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={feeSettings?.notificationTime}
              onChange={(e) => setFeeSettings({...feeSettings, notificationTime: e.target.value})}
            />
          </div>
          <div className="flex items-center space-x-3">
            <input
              type="checkbox"
              id="autoReminders"
              checked={feeSettings?.autoReminders}
              onChange={(e) => setFeeSettings({...feeSettings, autoReminders: e.target.checked})}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label htmlFor="autoReminders" className="text-sm font-medium text-gray-700">
              Enable automatic sms
            </label>
          </div>
        </div>
        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">SMS Template</label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            rows="3"
            value={feeSettings?.emailTemplate}
            onChange={(e) => setFeeSettings({...feeSettings, emailTemplate: e.target.value})}
          />
          <p className="text-xs text-gray-500 mt-1">
            System variables: [TERM_NAME], [AMOUNT], [DUE_DATE], [STUDENT_NAME], [PARENT_NAME], [PAYMENT_LINK] - <span className="text-red-700"> Do not modify these.</span>
          </p>
        </div>
         <button
              onClick={saveTermNotificationSettings}
              className="px-4 py-2 mt-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              Save Notification Settings
            </button>
      </div>
    </div>
  );

  const renderPayrollSettings = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <Users className="mr-3 text-green-600" size={24} />
          Payroll Processing Automation
        </h3>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
           <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Select Auto \/ Manual Processing</label>
              <select 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                value={payrollSettings.processingMode}
                onChange={(e) => setPayrollSettings({...payrollSettings, autoProcess: e.target.value})}
              >
                <option value="Auto">Auto Processing</option>
                <option value="Manual">Manual Processing</option>
                
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Processing Frequency</label>
              <select 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                value={payrollSettings.frequency}
                onChange={(e) => setPayrollSettings({...payrollSettings, frequency: e.target.value})}
              >
                <option value="monthly">Monthly</option>
                
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Process on Day</label>
              <input
                type="number"
                min="1"
                max="31"
                placeholder="4"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                value={payrollSettings.processDay}
                onChange={(e) => setPayrollSettings({...payrollSettings, processDay: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Process Time</label>
              <input
                type="time"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                value={payrollSettings.processTime}
                onChange={(e) => setPayrollSettings({...payrollSettings, processTime: e.target.value})}
              />
            </div>
           
          </div>

         

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Approval Recipients</label>
              <p className="text-sm text-gray-500 mb-3">Users who will receive approval links</p>
              {payrollSettings.approvers.map((email, index) => (
                <div key={index} className="flex gap-2 mb-2">
                  <input
                    type="email"
                    placeholder="approver@school.com"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    value={email}
                    onChange={(e) => updateEmail('approvers', index, e.target.value, setPayrollSettings, payrollSettings)}
                  />
                  {payrollSettings.approvers.length > 1 && (
                    <button
                      onClick={() => removeEmail('approvers', index, setPayrollSettings, payrollSettings)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={() => addEmail('approvers', setPayrollSettings, payrollSettings)}
                className="flex items-center text-green-600 hover:text-green-800 font-medium transition-colors mt-2"
              >
                <Plus size={16} className="mr-1" />
                Add Approver
              </button>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Report Recipients</label>
              <p className="text-sm text-gray-500 mb-3">Users who will receive payroll reports</p>
              {payrollSettings.reportRecipients.map((email, index) => (
                <div key={index} className="flex gap-2 mb-2">
                  <input
                    type="email"
                    placeholder="admin@school.com"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    value={email}
                    onChange={(e) => updateEmail('reportRecipients', index, e.target.value, setPayrollSettings, payrollSettings)}
                  />
                  {payrollSettings.reportRecipients.length > 1 && (
                    <button
                      onClick={() => removeEmail('reportRecipients', index, setPayrollSettings, payrollSettings)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={() => addEmail('reportRecipients', setPayrollSettings, payrollSettings)}
                className="flex items-center text-green-600 hover:text-green-800 font-medium transition-colors mt-2"
              >
                <Plus size={16} className="mr-1" />
                Add Recipient
              </button>
            </div>
          </div>
           <button
              onClick={savePayrollNotificationSettings}
              className="px-4 py-2 mt-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              Save Payroll Settings
            </button>
        </div>
      </div>
    </div>
  );

  const renderExpenseSettings = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-purple-50 to-violet-50 p-6 rounded-xl border border-purple-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <FileText className="mr-3 text-purple-600" size={24} />
          Recurring Expense Automation
        </h3>
        
        {expenseSettings.map((expense) => (
          <div key={expense.id} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Expense Name</label>
                <input
                  type="text"
                  placeholder="e.g., Office Rent"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  value={expense.name}
                  onChange={(e) => updateExpense(expense.id, 'name', e.target.value)}
                />
              </div>
             
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Category</label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  value={expense.category}
                  onChange={(e) => updateExpense(expense.id, 'category', e.target.value)}
                >
                  <option value="">Select If Recurring</option>
                  <option value="1">Recurring</option>
                  <option value="0">Non Recurring</option>
                </select>
              </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 items-end">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Frequency</label>
                <select 
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  value={expense.frequency}
                  onChange={(e) => updateExpense(expense.id, 'frequency', e.target.value)}
                >
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                  <option value="yearly">Yearly</option>
                  <option value="weekly">Weekly</option>
                  <option value="biannual">Bi-annual</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Process Date</label>
                <input
                  type="number"
                  min="1"
                  max="31"
                  placeholder="1"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  value={expense.processDate}
                  onChange={(e) => updateExpense(expense.id, 'processDate', e.target.value)}
                />
              </div>
             
           
            </div>
            
           
          </div>
        ))}
        
         <button
              onClick={saveExpenseNotificationSettings}
              className="px-4 py-2 mt-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              Save Expense Settings
            </button>
      </div>
    </div>
  );

  const renderTransportSettings = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-orange-50 to-amber-50 p-6 rounded-xl border border-orange-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <Truck className="mr-3 text-orange-600" size={24} />
          Transport Invoice Automation
        </h3>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Generation Date</label>
              <input
                type="number"
                min="1"
                max="31"
                placeholder="1"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                value={transportSettings.invoiceDate}
                onChange={(e) => setTransportSettings({...transportSettings, invoiceDate: e.target.value})}
              />
            </div>
           {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Amount</label>
              <input
                type="number"
                placeholder="0.00"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                value={transportSettings.amount}
                onChange={(e) => setTransportSettings({...transportSettings, amount: e.target.value})}
              />
            </div>*/}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Frequency</label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                value={transportSettings.frequency}
                onChange={(e) => setTransportSettings({...transportSettings, frequency: e.target.value})}
              >
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
                <option value="termly">Termly</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Send Time</label>
              <input
                type="time"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                value={transportSettings.sendTime}
                onChange={(e) => setTransportSettings({...transportSettings, sendTime: e.target.value})}
              />
            </div>
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id="notifyParents"
                checked={transportSettings.notifyParents}
                onChange={(e) => setTransportSettings({...transportSettings, notifyParents: e.target.checked})}
                className="h-4 w-4 text-orange-600 focus:ring-orange-500 border-gray-300 rounded"
              />
              <label htmlFor="notifyParents" className="text-sm font-medium text-gray-700">
                Notify parents via SMS
              </label>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">SMS Template</label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
              rows="3"
              value={transportSettings.smsTemplate}
              onChange={(e) => setTransportSettings({...transportSettings, smsTemplate: e.target.value})}
            />
            <p className="text-xs text-gray-500 mt-1">
              Available variables: [MONTH], [AMOUNT], [STUDENT_NAME], [PARENT_NAME] - <span className="text-red-700"> Do not modify these.</span>
            </p>
          </div>

          <div>
           <button
              onClick={saveTransportNotificationSettings}
              className="px-4 py-2 mt-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
            >
              Save Transport Settings
            </button>
          {/*  <label className="block text-sm font-medium text-gray-700 mb-2">Transport Routes</label>
          {transportSettings.routes.map((route, index) => (
              <div key={index} className="flex gap-2 mb-2">
                <input
                  type="text"
                  placeholder="e.g., Route A"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  value={route}
                  onChange={(e) => {
                    const updatedRoutes = [...transportSettings.routes];
                    updatedRoutes[index] = e.target.value;
                    setTransportSettings({...transportSettings, routes: updatedRoutes});
                  }}
                />
                {transportSettings.routes.length > 1 && (
                  <button
                    onClick={() => setTransportSettings({
                      ...transportSettings,
                      routes: transportSettings.routes.filter((_, i) => i !== index)
                    })}
                    className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                  >
                    <Trash2 size={16} />
                  </button>
                )}
              </div>
            ))}
            <button
              onClick={() => setTransportSettings({
                ...transportSettings,
                routes: [...transportSettings.routes, '']
              })}
              className="flex items-center text-orange-600 hover:text-orange-800 font-medium transition-colors mt-2"
            >
              <Plus size={16} className="mr-1" />
              Add Route
            </button>
            */}
          </div>

         {/* <button
            onClick={() => testAutomation('Transport Invoice')}
            className="px-4 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition-colors"
            disabled={isTestMode}
          >
            {isTestMode ? <RotateCcw className="animate-spin" size={16} /> : <Play size={16} />}
            Test Transport Automation
          </button>*/}
        </div>
      </div>
    </div>
  );

  const renderPayslipSettings = () => (
    <div className="space-y-8">
      <div className="bg-gradient-to-r from-teal-50 to-cyan-50 p-6 rounded-xl border border-teal-200">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <Mail className="mr-3 text-teal-600" size={24} />
          Payslip Distribution
        </h3>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Send Date</label>
              <input
                type="number"
                min="1"
                max="31"
                placeholder="25"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                value={payslipSettings.sendDate}
                onChange={(e) => setPayslipSettings({...payslipSettings, sendDate: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Send Time</label>
              <input
                type="time"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                value={payslipSettings.sendTime}
                onChange={(e) => setPayslipSettings({...payslipSettings, sendTime: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Frequency</label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                value={payslipSettings.frequency}
                onChange={(e) => setPayslipSettings({...payslipSettings, frequency: e.target.value})}
              >
                <option value="monthly">Monthly</option>
                <option value="biweekly">Bi-weekly</option>
                <option value="weekly">Weekly</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email Subject</label>
              <input
                type="text"
                placeholder="Your Payslip for [MONTH] [YEAR]"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                value={payslipSettings.emailSubject}
                onChange={(e) => setPayslipSettings({...payslipSettings, emailSubject: e.target.value})}
              />
              <p className="text-xs text-gray-500 mt-1">
                Available variables: [MONTH], [YEAR], [EMPLOYEE_NAME]
              </p>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email Recipients</label>
              {payslipSettings.recipients.map((email, index) => (
                <div key={index} className="flex gap-2 mb-2">
                  <input
                    type="email"
                    placeholder="employee@school.com"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    value={email}
                    onChange={(e) => updateEmail('recipients', index, e.target.value, setPayslipSettings, payslipSettings)}
                  />
                  {payslipSettings.recipients.length > 1 && (
                    <button
                      onClick={() => removeEmail('recipients', index, setPayslipSettings, payslipSettings)}
                      className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <Trash2 size={16} />
                    </button>
                  )}
                </div>
              ))}
              <button
                onClick={() => addEmail('recipients', setPayslipSettings, payslipSettings)}
                className="flex items-center text-teal-600 hover:text-teal-800 font-medium transition-colors mt-2"
              >
                <Plus size={16} className="mr-1" />
                Add Recipient
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email Body</label>
            <textarea
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              rows="5"
              value={payslipSettings.emailBody}
              onChange={(e) => setPayslipSettings({...payslipSettings, emailBody: e.target.value})}
            />
            <p className="text-xs text-gray-500 mt-1">
              Available variables: [MONTH], [YEAR], [EMPLOYEE_NAME]
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id="includeAttachments"
                checked={payslipSettings.includeAttachments}
                onChange={(e) => setPayslipSettings({...payslipSettings, includeAttachments: e.target.checked})}
                className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
              />
              <label htmlFor="includeAttachments" className="text-sm font-medium text-gray-700">
                Include payslip as attachment
              </label>
            </div>
            <div className="flex items-center space-x-3">
              <input
                type="checkbox"
                id="passwordProtected"
                checked={payslipSettings.passwordProtected}
                onChange={(e) => setPayslipSettings({...payslipSettings, passwordProtected: e.target.checked})}
                className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
              />
              <label htmlFor="passwordProtected" className="text-sm font-medium text-gray-700">
                Password-protect payslip attachments
              </label>
            </div>
          </div>

          <button
            onClick={() => testAutomation('Payslip Distribution')}
            className="px-4 py-2 bg-teal-100 text-teal-700 rounded-lg hover:bg-teal-200 transition-colors"
            disabled={isTestMode}
          >
            {isTestMode ? <RotateCcw className="animate-spin" size={16} /> : <Play size={16} />}
            Test Payslip Automation
          </button>
        </div>
      </div>
    </div>
  );

  const renderNotifications = () => (
    <div className="fixed bottom-4 right-4 space-y-2">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`flex items-center p-4 rounded-lg shadow-lg ${
            notification.type === 'success' ? 'bg-green-100 text-green-800' :
            notification.type === 'error' ? 'bg-red-100 text-red-800' :
            'bg-blue-100 text-blue-800'
          }`}
        >
          {notification.type === 'success' && <CheckCircle size={20} className="mr-2" />}
          {notification.type === 'error' && <AlertCircle size={20} className="mr-2" />}
          <div>
            <p className="text-sm font-medium">{notification.message}</p>
            <p className="text-xs text-gray-600">{notification.timestamp}</p>
          </div>
        </div>
      ))}
    </div>
  );

  const renderSystemStatus = () => (
    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      
    </div>
  );

  const renderAutomationLogs = () => (
    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      
    </div>
  );

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-800 flex items-center">
            <Settings className="mr-3 text-gray-600" size={28} />
            Automation Settings
          </h1>
          <div className="space-x-2">
            <button
              onClick={saveSettings}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Save All Settings
            </button>
            <button
              onClick={exportSettings}
              className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <Download size={16} className="inline mr-2" />
              Export Settings
            </button>
          </div>
        </div>

        <div className="flex border-b border-gray-200 mb-6">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center px-4 py-2 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? 'border-b-2 border-blue-600 text-blue-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <tab.icon size={18} className="mr-2" />
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mb-8">
          {activeTab === 'fees' && renderFeeAutomation()}
          {activeTab === 'payroll' && renderPayrollSettings()}
          {activeTab === 'expenses' && renderExpenseSettings()}
          {activeTab === 'transport' && renderTransportSettings()}
          {activeTab === 'payslips' && renderPayslipSettings()}
        </div>

        {renderSystemStatus()}
        <div className="mt-8">
          {renderAutomationLogs()}
        </div>

        {renderNotifications()}
      </div>
    </div>
  );
};

export default AdminAutomationSettings;